import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { DEFAULT_LANG, LANGS, languageFromPath } from "./config";
import nlCommon from "./locales/nl/common.json";
import enCommon from "./locales/en/common.json";
import frCommon from "./locales/fr/common.json";
import nlLegal from "./locales/nl/legal.json";
import enLegal from "./locales/en/legal.json";
import frLegal from "./locales/fr/legal.json";

// The active language always comes from the URL; no detector, no cookie.
if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: {
      nl: { common: nlCommon, legal: nlLegal },
      en: { common: enCommon, legal: enLegal },
      fr: { common: frCommon, legal: frLegal },
    },
    lng: typeof window === "undefined" ? DEFAULT_LANG : languageFromPath(window.location.pathname),
    fallbackLng: DEFAULT_LANG,
    supportedLngs: [...LANGS],
    defaultNS: "common",
    ns: ["common", "legal"],
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });
}

/** Safe language switch: never touches i18next before its services exist. */
export function setLanguage(lang: string) {
  if (!i18n.isInitialized) {
    i18n.on("initialized", () => {
      if (i18n.language !== lang) void i18n.changeLanguage(lang);
    });
    return;
  }
  if (i18n.language !== lang) void i18n.changeLanguage(lang);
}

export { i18n };
